<template>
  <div>
    <b-sidebar
      class="bundle-sidebar"
      @hidden="hidden()"
      :ref="'bundle_sidebar'"
      :visible="is_active_sidebar('bundle_sidebar_' + bundle.id)"
      backdrop
      right
      shadow
      :id="'bundle_sidebar_' + bundle.id"
      :title="bundle.title"
      :class="'my-sidebar-popup'"
    >
      <div>
        <div class="bundle-sidebar-header">
          <div id="bundle_filter_list">
            <div class="row">
              <div
                :class="{ active: active_bundle_filter == item.bundle_type }"
                class="col bundle-filter-item"
                v-for="(item, index) in bundles_durations"
                :key="index"
              >
                <div
                  class="text-truncate"
                  @click="set_bundle_filter(item.bundle_type)"
                >
                  {{ item.bundle_type.replace("Forfaits", "") }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion" role="tablist">
          <b-card
            v-for="(item, index) in bundle_list"
            :key="item.id + '_' + index"
            no-body
            class="collapsed"
            v-show="active_bundle_filter == item.bundle_type"
          >
            <b-card-header header-tag="header" class="p-1" role="tab">
              <div
                class="bundle-activation-card-header"
                v-b-toggle="'accordion' + index"
              >
                <div class="font-weight-bold">{{ item.price }} FCFA</div>
                <p class="text-muted">{{ item.description }}</p>
                <span
                  class="kgk-mtn-keyboard_arrow_down icon-not-collapsed"
                ></span>
                <span
                  class="kgk-mtn-keyboard_arrow_right icon-collapsed"
                ></span>
              </div>
            </b-card-header>
            <b-collapse
              :id="'accordion' + index"
              visible
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <BundleDetails :bdl="item" />
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import BundleDetails from "./BundleDetails";
export default {
  components: { BundleDetails },
  props: ["bundle", "bundle_list"],
  name: "BundlePopup",
  mounted: async function () {
    this.get_bundle_durations();
  },
  data: () => {
    return {
      bundles_durations: [],
      active_bundle_filter: null,
      current_bundle: "",
    };
  },
  methods: {
    get_bundle_durations: function () {
      var bundle_filter_list = _.uniqBy(this.bundle_list, "bundle_type");
      this.active_bundle_filter = bundle_filter_list[0].bundle_type;
      this.bundles_durations = bundle_filter_list;
    },
    hidden: function (el) {
      this.toggle_sidebar(null);
    },
    set_bundle_filter: function (filter) {
      this.active_bundle_filter = filter;
    },
  },
};
</script>
<style scoped>
.row {
  flex-wrap: nowrap;
  width: 100% !important;
  overflow-x: auto;
  margin: 0 !important;
}
#bundle_filter_list >div {
  padding: 0 !important;
}
.row::-webkit-scrollbar {
    display: none !important
}
</style>